import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { ToastContainer } from "react-toastify";

import Login from "./components/Auth/Login";
import SignUp from "./components/Auth/SignUp";
import ForgotPassword from "./components/Auth/ForgotPassword";
import ResetPassword from "./components/Auth/ResetPassword";
import Home from "./components/Home/Home";
import Error from "./components/Error";
// import OAuthRedirect from './components/OAuthRedirect';
import Dashboard from "./components/Dashboard/Dashboard";
import GoogleAdsCallback from "./components/AdAuthCallbacks/GoogleAdsCallback";
import ProtectedRoute from "components/Auth/ProtectedRoute";
import MetaAdsCallback from "components/AdAuthCallbacks/MetaAdsCallback";
import TikTokAdsCallback from "./components/AdAuthCallbacks/TikTokAdsCallback";
import SnapchatAdsCallback from "./components/AdAuthCallbacks/SnapchatAdsCallback";
import LinkedInAdsCallback from "./components/AdAuthCallbacks/LinkedInAdsCallback";
import ShopifyOAuthAdsCallback from "components/AdAuthCallbacks/ShopifyOAuthAdsCallback";
import LegalDocument from "./components/Legal/LegalDocument";

const App = () => {
  return (
    <>
      <Router>
        <Routes>
          {/* Auth */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Home */}
          <Route path="/" element={<Home />} />

          {/* Legal */}
          <Route path="/privacy-policy" element={<LegalDocument documentType="privacy" />} />
          <Route path="/terms-of-service" element={<LegalDocument documentType="terms" />} />

          {/* Dashboard */}
          <Route
            path="/dashboard/*"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          {/* Ad Callbacks */}
          <Route
            path="/ads/google-callback"
            element={
              <ProtectedRoute>
                <GoogleAdsCallback />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ads/meta-callback"
            element={
              <ProtectedRoute>
                <MetaAdsCallback />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ads/tiktok-callback"
            element={
              <ProtectedRoute>
                <TikTokAdsCallback />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tiktok-ads-callback"
            element={
              <ProtectedRoute>
                <TikTokAdsCallback />
              </ProtectedRoute>
            }
          />

          <Route
            path="/ads/snap-callback"
            element={
              <ProtectedRoute>
                <SnapchatAdsCallback />
              </ProtectedRoute>
            }
          />

          <Route
            path="/ads/linkedin-callback"
            element={
              <ProtectedRoute>
                <LinkedInAdsCallback />
              </ProtectedRoute>
            }
          />

          <Route
            path="/ads/shopify-callback"
            element={
              <ProtectedRoute>
                <ShopifyOAuthAdsCallback />
              </ProtectedRoute>
            }
          />

          {/* Error */}
          <Route path="/error" element={<Error />} />
        </Routes>
      </Router>
      <ToastContainer />
    </>
  );
};

export default App;
